// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PodsGradientIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 40 40">
    <path
      fill="url(#pods-gradient_svga)"
      fillRule="evenodd"
      d="M33.55 13.08 20.35 5 7.4 13.08l12.93 8.08zM6.67 15l12.7 7.7V35l-12.7-7.7zm27.63 0-12.7 7.7V35l12.7-7.7z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="pods-gradient_svga"
        x1={6.67}
        x2={37.18}
        y1={5}
        y2={31.71}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "PodsGradient",
);
export default PodsGradientIcon;
